import './track-js'
import './errorHandler'
import './ketch'
import './analytics/googleTagManager'
import dataDogLoader from './dataDog'

dataDogLoader()
